import Vue from 'vue';
import axios from 'axios';


// Power Reviews API
const MERCHANT_ID = 877647;
const LOCALE = "en_US";
const API_KEY = "7c4da1e0-28bd-4d6a-839e-7bced28cbe1b";

// let isOnline = navigator.onLine;

function getIsOnline() {
  return navigator.onLine;
}

/*
    Actions
    work as a service, get the data and send to the mutations.js objects
*/
let actions = {


    // GET PRODUCT DETAIL FROM CMS
  get_product_details({ commit }, product) {
    if (!product) {
      console.log('no product to get details');
      return;
    }

    if (getIsOnline()){

            Vue.http.get(`https://amerisleep-cms.firebaseio.com/${product}.json`)

                .then(res => res.json())

                .then(data =>{

                    // Commit data to mutation
                    commit('UPDATE_PRODUCT_DETAILS', data);

                });

        }else{

            console.log('[ACTION] YOU ARE OFFLINE')

        }

    },


    // GET PRODUCT REVIEW AVERAGE FROM POWER REVIEWS API
    get_product_reviews_average( {commit}, product ){
      if (!product) {
        console.log('no product to get reviews average');
        return;
      }
      if (getIsOnline()){

            let PRODUCT = product.toUpperCase();

            switch (PRODUCT) {
                case 'AS1':
                    PRODUCT = 132;
                    break;
                case 'AS2':
                    PRODUCT = 128;
                    break;
                case 'AS3':
                    PRODUCT = 130
                    break;
                case 'AS4':
                    PRODUCT = 141;
                    break;
                case 'AS5':
                    PRODUCT = 137;
                    break;
                default:
                    PRODUCT = '';
            }
            if (!PRODUCT) {
                console.log('[ERROR] INVALID PRODUCT DURING RATINGS COMMIT');
                return;
            }

            const PAGE_SIZE = 1;

            let url = "https://readservices-b2c.powerreviews.com/m/" + MERCHANT_ID + "/l/" + LOCALE + "/product/" + PRODUCT + "/reviews?paging.size=" + PAGE_SIZE + "&apikey=" + API_KEY + "&format=json";

            axios.get(url)

                .then(res => {return res})

                .then(data =>{

                    // Commit data to mutation
                    commit('UPDATE_PRODUCT_REVIEW_AVERAGE', data.data);

                }).catch(err => {
                    console.log('[ERROR] CANNOT RETRIEVE REVIEWS', err)
                });

        }else{

            console.log('[ACTION] YOU ARE OFFLINE');

        }

    },


    // GET PRODUCT REVIEWS FROM POWER REVIEWS API
  get_product_reviews({ commit }, payload) {
    if (!payload) {
      console.log('no product to get details');
      return;
    }

      if (getIsOnline()){

            let PRODUCT = payload.product.toUpperCase();

            switch (PRODUCT) {
                case 'AS1':
                    PRODUCT = 132;
                    break;
                case 'AS2':
                    PRODUCT = 128;
                    break;
                case 'AS3':
                    PRODUCT = 130
                    break;
                case 'AS4':
                    PRODUCT = 141;
                    break;
                case 'AS5':
                    PRODUCT = 137;
                    break;
                default:
                    PRODUCT = '';
            }

            if (!PRODUCT) {
                return;
            }

            const PAGE_SIZE = 20;

            let paging = payload.page * PAGE_SIZE; // paging.from = next page * items per page

            let url = "https://readservices-b2c.powerreviews.com/m/" + MERCHANT_ID + "/l/" + LOCALE + "/product/" + PRODUCT + "/reviews?paging.size=" + PAGE_SIZE + "&paging.from=" + paging + "&apikey=" + API_KEY + "&format=json";

            axios.get(url)

                .then(res => {return res})

                .then(data =>{

                    // Commit data to mutation
                    commit('UPDATE_PRODUCT_REVIEWS', data.data);

                }).catch(err => {
                    console.log('[ERROR] CANNOT RETRIEVE REVIEWS', err)
                });


        }else{

            console.log('[ACTION] YOU ARE OFFLINE');

        }

    }

};

export default actions;



// WEBPACK FOOTER //
// ./src/vuex/actions.js